import { render, staticRenderFns } from "./Newfhk.vue?vue&type=template&id=aea8fd46&scoped=true&"
import script from "./Newfhk.vue?vue&type=script&lang=js&"
export * from "./Newfhk.vue?vue&type=script&lang=js&"
import style0 from "./Newfhk.vue?vue&type=style&index=0&id=aea8fd46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea8fd46",
  null
  
)

export default component.exports